<template>

<div>

  <LDBsTable
    url="movementtype"
    defaultSort="name"
    defaultOrder="asc"
    :query="query"
    :columns="columns"
    :clear="clear"
    :defaultOptions='options'
  >
    <div class="form-group col-6">
      <label for="active_type">{{ $t('active_type') }}</label>
      <Combobox
        class="bg-white"
        name='actives_type'
        :placeholder="$t('select_a_item')"
        label="name"
        :options="activestypes"
        v-model="query.activeType"
        :reduce="activesTypes => activesTypes.id"
      />
    </div>

    <div class="form-group col-6">
      <label>{{ $t('movement_type') }}</label>
      <input
        type="text"
        name="name"
        class="form-control"
        v-model="query.name"
        :placeholder="$t('ph_movement_type')"
      >
    </div>
  </LDBsTable>

</div>

</template>

<script>
import { mapState, mapActions } from 'vuex'
import LDBsTable from '@/components/shared/LDBsTable'
import Combobox from '@/components/shared/ComboBox'

export default {
  name: 'MovementTypeList',
  components: {
    LDBsTable,
    Combobox
  },

  data () {
    return {
      columns: [
        {
          title: this.$t('active_type'),
          field: 'activeType',
          formatter: value => {
            return value
              ? value.name
              : '-'
          },
          sortable: true
        },
        {
          title: this.$t('movement_type'),
          field: 'name',
          sortable: true
        },
        {
          key: 'id',
          field: 'id',
          align: 'center',
          width: '100%',
          formatter: function (value) {
            return `
              <a
                href="#/main/movementtype/${value}"
                class="edit btn btn-action btn-primary btn-circle light-bottom-shadow text-white"
              >
                <i class="fas fa-pen" />
              </a>`
          },
        }
      ],

      options: {
        exportOptions: { fileName: 'tipos_movimentacao_ativos' }
      },

      query: {
        name: '',
        activeType: undefined
      }
    }
  },

  computed: {
    ...mapState({
      activestypes: state => state.activestype.all,
      isLoading: state => state.movementtype.isLoading
    })
  },

  methods: {
    clear() {
      this.query.name = '',
      this.query.activeType = undefined
    }
  },

  async mounted() {
    const { dispatch } = this.$store

    await dispatch('activestype/fetchAll')
  }
}

</script>
